<template>
  <div>
    <div ref="pageTopAnchor" style="height:80px;margin-top:-80px;"></div>
    <div class="ceiling">
      <home-top></home-top>
      <top-search :showHot="true" type="home"></top-search>
      <navicat background="#ffffff" :current="8"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="boxy-content">
      <div class="inner w-1400">
        <div class="bread-crumb w-1400">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>技术项目交易</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="cart-gray">
          <div class="cart-line">
            <div class="cart-line-title">技术类型：</div>
            <template v-if="technologyList.length>0">
              <div
                  @click="handleTechnology(item.value)"
                  v-for="item in technologyList"
                  :key="item.id"
                  :class="
                            tech_type === item.value
                              ? 'cart-line-item-active cart-line-item'
                              : 'cart-line-item'"
              >
                {{ item.label }}
              </div>
            </template>
            <div style="flex: 1" v-else>
              <el-skeleton animated>
                <template slot="template">
                  <el-skeleton-item variant="p" style="width: 60px;height: 20px;margin-right: 30px" v-for="i in 2"
                                    :key="i"/>
                </template>
              </el-skeleton>
            </div>
          </div>
          <div class="cart-line">
            <div class="cart-line-title">合作方式：</div>
            <template v-if="coTypeList.length>0">
              <div
                  @click="handleCoType(item.label)"
                  v-for="item in coTypeList"
                  :key="item.id"
                  :class="
                co_type === item.label
                  ? 'cart-line-item-active cart-line-item'
                  : 'cart-line-item'
              "
              >
                {{ item.label }}
              </div>
            </template>
            <div style="flex: 1" v-else>
              <el-skeleton animated style="padding-top: 7px">
                <template slot="template">
                  <el-skeleton-item variant="p" style="width: 60px;height: 20px;margin-right: 30px" v-for="i in 6"
                                    :key="i"/>
                </template>
              </el-skeleton>
            </div>
          </div>
          <div class="cart-line">
            <div class="cart-line-title">交易价格：</div>
            <template v-if="techPriceList.length>0">
              <div
                  @click="handleTechPrice(item.value)"
                  v-for="item in techPriceList"
                  :key="item.id"
                  :class="
                price === item.value
                  ? 'cart-line-item-active cart-line-item'
                  : 'cart-line-item'
              "
              >
                {{ item.label }}
              </div>
            </template>
            <div style="flex: 1" v-else>
              <el-skeleton animated style="padding-top: 7px">
                <template slot="template">
                  <el-skeleton-item variant="p" style="width: 80px;height: 20px;margin-right: 30px" v-for="i in 5"
                                    :key="i"/>
                </template>
              </el-skeleton>
            </div>
          </div>
          <div class="cart-line">
            <div class="cart-line-title">技术成熟度：</div>
            <template v-if="techMaturityList.length>0">
              <div
                  @click="handleTechMaturity(item.label)"
                  v-for="item in techMaturityList"
                  :key="item.id"
                  :class="
                tech_maturity === item.label
                  ? 'cart-line-item-active cart-line-item'
                  : 'cart-line-item'
              "
              >
                {{ item.label }}
              </div>
            </template>
            <div style="flex: 1" v-else>
              <el-skeleton animated style="padding-top: 7px">
                <template slot="template">
                  <el-skeleton-item variant="p" style="width: 60px;height: 20px;margin-right: 30px" v-for="i in 5"
                                    :key="i"/>
                </template>
              </el-skeleton>
            </div>
          </div>
          <div class="cart-line">
            <div class="cart-line-title">买卖技术：</div>
            <template v-if="buySellList.length>0">
              <div
                  @click="handleBuySell(item.value)"
                  v-for="item in buySellList"
                  :key="item.value"
                  :class="
                type === item.value
                  ? 'cart-line-item-active cart-line-item'
                  : 'cart-line-item'
              "
              >
                {{ item.label }}
              </div>
            </template>
            <div style="flex: 1" v-else>
              <el-skeleton animated style="padding-top: 7px">
                <template slot="template">
                  <el-skeleton-item variant="p" style="width: 60px;height: 20px;margin-right: 30px" v-for="i in 2"
                                    :key="i"/>
                </template>
              </el-skeleton>
            </div>
          </div>
        </div>
        <!-- 搜索框 -->
        <div class="content-search">
          <div class="content-search-box">
            <el-input
                placeholder="请输入CAS号、中文名称、英文名称"
                v-model="keyword"
                @input="searchInput"
            >
              <el-button
                  slot="append"
                  @click="getSearchList"
                  class="search-btn hit-cursor"
              >搜索
              </el-button
              >
            </el-input>
          </div>
        </div>
        <!--        v-loading="loading"-->
        <div class="goods-list-box">
          <div class="goods-list" v-if="loading">
            <el-skeleton style="width: 310px;height: 190px" animated v-for="i  in 8" :key="i">
              <template slot="template">
                <div style="display: flex; align-items: center; justify-content: space-between; ">
                  <el-skeleton-item variant="p" style="width: 20%;height: 24px"/>
                  <el-skeleton-item variant="p" style="width: 40%;height: 24px"/>
                  <el-skeleton-item variant="p" style="width: 30%;height: 24px"/>
                </div>

                <div style="padding: 14px 0;">
                  <div>
                    <el-skeleton-item variant="p" style="width: 50%;height: 20px"/>
                  </div>
                  <div>
                    <el-skeleton-item variant="p" style="width: 50%;height: 20px"/>
                  </div>
                  <div
                      style="display: flex; align-items: center; justify-content: space-between; padding: 5px 0;"
                  >
                    <el-skeleton-item variant="text" style="width: 40%;height: 20px;margin-right: 14px"/>
                    <el-skeleton-item variant="text" style="width: 40%;height: 20px;"/>
                  </div>

                </div>
                <div
                    style="display: flex; align-items: center; justify-content: space-between;padding: 5px 0;"
                >
                  <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                  <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                  <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                  <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                </div>
              </template>
            </el-skeleton>
          </div>
          <div class="goods-list" v-if="goodsList.length > 0&&!loading">
            <div
                v-for="(item, index) in goodsList"
                :key="index"
                class="goods-list-item"
            >
              <pur-card :data="item"></pur-card>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination" v-if="goodsList.length > 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[20, 40, 60, 100]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
          </div>
          <empty v-if="goodsList.length === 0"></empty>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeTop from "../../components/public/home-top.vue";
import topSearch from "../../components/public/top-search.vue";
import navicat from "../../components/navicat/navicat.vue";
import classfily from "../../components/public/classfily.vue";
import purCard from "../../components/goods/pur-card.vue";
import homeFooter from "../../components/public/home-footer.vue";
import empty from "../../components/public/empty.vue";
import {getTechFilter} from "@/api/modules/common";
import {tech_list_api} from "@/api/modules/home";

export default {
  name: "purchase",
  components: {
    homeTop,
    topSearch,
    navicat,
    classfily,
    purCard,
    homeFooter,
    empty,
  },
  data() {
    return {
      keyword: "",
      currentPage4: 1,
      tarBarList: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "商城",
          path: "/shop",
        },
        {
          name: "原料采购专区",
          path: "/purchase",
        },
        {
          name: "原料供应专区",
          path: "/supply",
        },
        {
          name: "化工资讯",
          path: "/ruitian-news",
        },
        {
          name: "关于我们",
          path: "/about-us",
        },
        {
          name: "行业工具",
          path: "/industry-tools",
        },
        {
          name: "技术项目交易",
          path: "/project-transaction",
        },
      ],
      goodsList: [],
      coTypeList: [],
      technologyList: [],
      techMaturityList: [],
      techPriceList: [],
      buySellList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "买技术",
        },
        {
          value: "2",
          label: "卖技术",
        },
      ],
      total: 0,
      pageSize: 20,
      pageNum: 1,
      tech_type: "",
      co_type: "全部",
      price: "",
      tech_maturity: "全部",
      type: "",
      loading: true,
    };
  },
  created() {
    this.getTechList();
    this.init();
  },
  methods: {
    searchInput(val) {
      if (val.trim() === "") {
        this.getTechList();
      }
    },
    getSearchList() {
      if (this.keyword.trim() === "") {
        this.$message.warning({
          message: "请输入关键词",
          type: "warning",
          duration: 2000,
          offset: 300,
        });
        return;
      }
      this.pageNum = 1;
      this.getTechList();
    },
    init() {
      getTechFilter().then((res => {
        if (res.data.code == 10000) {
          let data = res.data.data
          // 获取技术类型字典项
          this.technologyList = data.tech_type;
          this.technologyList.unshift({
            value: "",
            label: "全部",
          });
          // 获取合作方式字典项
          this.coTypeList = data.co_type;
          this.coTypeList.unshift({
            value: "",
            label: "全部",
          });
          // 获取交易价格字典项
          this.techPriceList = data.tech_price;
          this.techPriceList.unshift({
            value: "",
            label: "全部",
          });
          // 获取技术成熟度字典项
          this.techMaturityList = data.tech_maturity;
          this.techMaturityList.unshift({
            value: "",
            label: "全部",
          });
        }
      }))
    },
    // 技术类型切换
    handleTechnology(value) {
      this.tech_type = value;
      this.getTechList();
    },
    // 合作方式切换
    handleCoType(lable) {
      this.co_type = lable;
      this.getTechList();
    },
    // 交易价格切换
    handleTechPrice(lable) {
      this.price = lable;
      this.getTechList();
    },
    // 技术成熟度切换
    handleTechMaturity(lable) {
      this.tech_maturity = lable;
      this.getTechList();
    },
    // 买卖技术切换
    handleBuySell(value) {
      this.type = value;
      this.getTechList();
    },
    getTechList() {
      this.loading = true;
      tech_list_api({
        page: this.pageNum,
        limit: this.pageSize,
        tech_type: this.tech_type,
        co_type: this.co_type === "全部" ? "" : this.co_type,
        price: this.price === "全部" ? "" : this.price,
        tech_maturity: this.tech_maturity === "全部" ? "" : this.tech_maturity,
        type: this.type === "全部" ? "" : this.type,
        keywords: this.keyword,
      }).then((res) => {
        if (res.data.data) {
          this.goodsList = res.data.data.data;
          this.total = res.data.data.total;
        }
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTechList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.$refs.pageTopAnchor?.scrollIntoView({behavior: 'auto', block: 'start'})
      this.getTechList();
    },
  },
};
</script>
<style lang="scss" scoped>
.h-top {
  height: 265px;
}

.boxy-content {
  .bread-crumb {
    margin: 20px 0;
  }

  //   padding-top: 50px;
  .inner {
    .cart-gray {
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #e7eaf3;
      margin-bottom: 20px;

      .cart-line {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 10px 20px;
        gap: 30px;
        border-bottom: 1px solid #e7eaf3;
        line-height: 40px;
        font-size: 16px;

        .cart-line-title {
          width: 110px;
          font-weight: 600;
          color: #00112b;
        }

        .cart-line-item {
          cursor: pointer;
          color: #525666;

          &:hover {
            color: #21428a;
          }
        }

        .cart-line-item-active {
          background: #4b87ff;
          color: #fff;
          border-radius: 6px;
          padding: 0 12px;
        }
      }
    }
  }

  .content-search {
    margin-bottom: 20px;

    .content-search-box {
      width: 666px;
      height: 62px;

      .search-btn {
        width: 150px;
        height: 63px;
        background: #4b87ff;
        border-radius: 0px 6px 6px 0px;
        text-align: center;
        font-size: 20px;
        // line-height: 63px;
        color: #fff;
      }

      ::v-deep .el-input__inner {
        height: 62px !important;
      }

      ::v-deep .el-input {
        height: 62px !important;
      }
    }
  }

  .goods-list-box {
    background: #fff;
    padding: 50px 30px;
    margin-bottom: 35px;

    .goods-list {
      display: grid;
      grid-template-columns: repeat(4, 1fr); // 4等分
      gap: 20px 0px;
      flex-wrap: wrap;

      .goods-list-item {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .pagination {
      text-align: right;
      margin: 20px 0 0;
    }
  }
}

.height-200 {
  height: 134px;
}
</style>
